import scene from "./Scene";
import camera from "./Camera";
import renderer from "./Rendered";
import light from "./Light";
import { useRef, useEffect } from "react";
import "./Orbit.js";
import GUI from 'lil-gui';
import gltfLoader from "./gltfLoader";
import * as THREE from "three";
import plane from "./plane"
import CardTexture from "./faceTexture";
import { Vector2 } from "three";


const Template = () => {
  const mountRef = useRef(null);

  useEffect(() => {

    const Card = new THREE.Group();
    gltfLoader.load(
      "./Models/devcard.gltf",
      (gltf) => {

        gltf.scene.traverse(function (child) {
          if (child.isMesh) {
            child.castShadow = true;
            child.receiveShadow = true;
          }
        })

        Card.add(gltf.scene);
        Card.scale.set(0.2, 0.2, 0.2);
        Card.position.y = 0.5;
        scene.add(Card);
        
      }
    );



    //Data from the canvas
    const currentRef = mountRef.current;
    const { clientWidth: width, clientHeight: height } = currentRef;

    //Scene, camera, renderer
    scene.add(camera);
    scene.add(light)
    camera.position.set(0, 0.1, 1.5);
    camera.lookAt(Card.position);
    scene.add(plane)
    renderer.setSize(width, height);
    currentRef.appendChild(renderer.domElement);

    //gui
    const gui = new GUI();
    // Create color pickers for multiple color formats
    const colorFormats = {
      Color: '#ffffff',
      int: 0x530909,
      object: { r: 1, g: 1, b: 1 },
      array: [1, 1, 1]
    };



    const guiTextureRotation = {

      Texture: 'https://',
      TextureRotation: 0,
      TexturePositionX: 0,
      TexturePositionY: 0,
      RotationX: 0,
      RotationY: 0,
      RotationZ: 0,
      Reset: function () {
        Card.children[0].rotation.set(0, 0, 0);
        gui.reset();
        Card.children[0].children[8].material.map = null;
      },
    };
    var imageTexture = false;

    const folderTexture = gui.addFolder( 'Texture' );

    gui.addColor(colorFormats, 'Color').onChange(() => {
      Card.children[0].children[8].material.color.set(colorFormats.Color);
      Card.children[0].children[0].material.color.set(colorFormats.Color);
    });

    gui.add(guiTextureRotation, 'RotationX', 0, 5).name("Rotation X").onChange(() => {
      Card.children[0].rotation.x = guiTextureRotation.RotationX;
    });
    gui.add(guiTextureRotation, 'RotationY', 0, 5).name("Rotation Y").onChange(() => {
      Card.children[0].rotation.y = guiTextureRotation.RotationY;
    });
    gui.add(guiTextureRotation, 'RotationZ', 0, 5).name("Rotation Z").onChange(() => {
      Card.children[0].rotation.z = guiTextureRotation.RotationZ;
    });
    folderTexture.add(guiTextureRotation, 'Texture').onChange(() => {
      const map = CardTexture(guiTextureRotation.Texture);
      Card.children[0].children[8].material.map = map;
      Card.children[0].children[8].material.needsUpdate = true;
      imageTexture = true;
    });
    folderTexture.add(guiTextureRotation, 'TextureRotation', 0, 10).onChange(() => {
      if (imageTexture) {
        const map = CardTexture(guiTextureRotation.Texture);
        map.rotation = guiTextureRotation.TextureRotation;
        map.center = new Vector2(0.5, 0.5);
        map.offset.x = guiTextureRotation.TexturePositionX;
        map.offset.y = guiTextureRotation.TexturePositionY;
        Card.children[0].children[8].material.map = map;
        Card.children[0].children[8].material.needsUpdate = true;
      }
    });

    folderTexture.add(guiTextureRotation, 'TexturePositionX', 0, 10).onChange(() => {
      if (imageTexture) {
        const map = CardTexture(guiTextureRotation.Texture);
        map.rotation = guiTextureRotation.TextureRotation;
        map.offset.x = guiTextureRotation.TexturePositionX;
        map.offset.y = guiTextureRotation.TexturePositionY;
        Card.children[0].children[8].material.map = map;
        Card.children[0].children[8].material.needsUpdate = true;
      }

    });

    folderTexture.add(guiTextureRotation, 'TexturePositionY', 0, 10).onChange(() => {
      if (imageTexture) {
        const map = CardTexture(guiTextureRotation.Texture);
        map.rotation = guiTextureRotation.TextureRotation;
        map.offset.x = guiTextureRotation.TexturePositionX;
        map.offset.y = guiTextureRotation.TexturePositionY;
        Card.children[0].children[8].material.map = map;
        Card.children[0].children[8].material.needsUpdate = true;
      }

    });

 

    gui.add(guiTextureRotation, 'Reset');


    //Resize canvas

    renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
    camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
    camera.updateProjectionMatrix();

    const resize = () => {
      renderer.setSize(currentRef.clientWidth, currentRef.clientHeight);
      camera.aspect = currentRef.clientWidth / currentRef.clientHeight;
      camera.updateProjectionMatrix();
    };
    window.addEventListener("resize", resize);

    //Animate the scene
    const animate = () => {

      renderer.render(scene, camera);
      requestAnimationFrame(animate);

    };
    animate();


    return () => {
      window.removeEventListener("resize", resize);
      currentRef.removeChild(renderer.domElement);
    };
  }, []);

  return (
    <div
      ref={mountRef}
      style={{ width: "100%", height: "1000px" }}
    ></div>
  );
};

export default Template;



